import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  model,
  Output,
  signal,
} from "@angular/core";
import {
  DxStepperModule,
  type DxStepperTypes,
} from "devextreme-angular/ui/stepper";
import { dxStepperItem, Item } from "devextreme/ui/stepper";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { IconName } from "src/app/helpers/icon-exports";

export interface StepperItem {
  id: string;
  title: string;
  icon: IconName;
  isCompleted?: boolean;
  disabled?: boolean;
}

export interface StepperNavigationEvent {
  previousIndex: number;
  currentIndex: number;
  item: StepperItem;
}

@Component({
    selector: "gpd-stepper",
    imports: [CommonModule, DxStepperModule, SvgIconComponent],
    templateUrl: "./gpd-stepper.component.html",
    styleUrl: "./gpd-stepper.component.css",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GpdStepperComponent {
  // Constants
  private readonly ICON_SIZE = 18;
  private readonly ICON_STROKE_WIDTH = 1.5;
  private readonly STEP_WIDTH = 150;

  items = input.required<StepperItem[]>();
  public selectedIndex = model<number>(0);

  // Outputs
  @Output() selectionChanged = new EventEmitter<StepperNavigationEvent>();

  // Computed properties
  stepperItems = computed(() => {
    return this.items()?.map((item, index) => ({
      text: item.title,
      icon: item.icon,
      id: item.id,
      index: index,
      disabled: item.disabled,
    })) as Item[];
  });

  stepperWidth = computed(() => this.items().length * this.STEP_WIDTH);

  // Getters for template access
  get iconSize() {
    return this.ICON_SIZE;
  }
  get iconStrokeWidth() {
    return this.ICON_STROKE_WIDTH;
  }

  constructor() {}

  onStepClicked(index: number) {
    const previousIndex = this.selectedIndex();
    const item = this.items()[index];

    this.selectionChanged.emit({
      previousIndex,
      currentIndex: index,
      item,
    });
  }
}
